import { render, staticRenderFns } from "./main.vue?vue&type=template&id=feaba6ce&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&id=feaba6ce&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaba6ce",
  null
  
)

export default component.exports